import { createAsyncThunk } from '@reduxjs/toolkit';
import * as selfEnrollmentService from './self-enrollment-api';
import {
    ICancelSelfEnrollmentRequest,
    ICreateSelfEnrollmentRequest,
    IGetEnrolledRequest,
} from '../../../constants/self-enrollment';

export const getEnrolledSkills = createAsyncThunk(
    'selfEnrollment/getEnrolledSkills',
    async ({ skillIds }: IGetEnrolledRequest, { rejectWithValue }) => {
        try {
            const response = await selfEnrollmentService.getEnrolledSkills({
                skillIds,
            });
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const getEnrolledSkill = createAsyncThunk(
    'selfEnrollment/getEnrolledSkill',
    async ({ skillIds }: IGetEnrolledRequest, { rejectWithValue }) => {
        try {
            const response = await selfEnrollmentService.getEnrolledSkills({
                skillIds,
            });
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const createSelfEnrollment = createAsyncThunk(
    'selfEnrollment/createSelfEnrollment',
    async (payload: ICreateSelfEnrollmentRequest, { rejectWithValue }) => {
        try {
            const response = await selfEnrollmentService.createSelfEnrollment(
                payload
            );
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const cancelSelfEnrollment = createAsyncThunk(
    'selfEnrollment/cancelSelfEnrollment',
    async (payload: ICancelSelfEnrollmentRequest, { rejectWithValue }) => {
        try {
            const response = await selfEnrollmentService.cancelSelfEnrollment(
                payload
            );
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);
